import React from "react";
import { Grid, Section, Typography, Button } from "../../core";
import { useHistory } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { theme } from "../../styles";
import SizerListTabel from "../../components/SizerList";
import { useSizerData } from "../../hooks/useSizerData";

const { colors } = theme;
const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
  margin: "0px 0px 0px auto",
};
const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};
const SizerList = () => {
  useSizerData();
  const history = useHistory();
  function clickHandler(params) {
    history.push("/add-sizer");
  }
  return (
    <Grid>
      {/* <Container className="d-flx"> */}
      <Section className="mt-10" padding="20px 20px">
        <Button {...btnProps} onClick={clickHandler}>
          <Typography {...typoProps} noMargin>
            <PlusOutlined />
            Add Sizer
          </Typography>
        </Button>
      </Section>
      {/* </Container> */}
      <Section className="mt-10" padding="0px 20px">
        <SizerListTabel />
      </Section>
    </Grid>
  );
};

export default SizerList;
